"use client";

import { motion } from "framer-motion";
import { CreditCard, BarChart3, ShieldCheck, Heart, FileText, Wifi, ArrowRight } from "lucide-react";
import Link from "next/link";

const addOns = [
  {
    icon: <CreditCard size={26} />,
    title: "Bank Account Opening",
    description: "Fast-track business banking setup with the right UAE banking solutions for your needs.",
  },
  {
    icon: <BarChart3 size={26} />,
    title: "Accounting Services",
    description: "Bookkeeping, financial reporting, payroll, VAT filing, and audit support all handled.",
  },
  {
    icon: <ShieldCheck size={26} />,
    title: "Compliance Services",
    description: "ESR, UBO, and all UAE regulatory requirements managed by our compliance experts.",
  },
  {
    icon: <Heart size={26} />,
    title: "Health Insurance",
    description: "Flexible individual and group health insurance plans from leading UAE providers.",
  },
  {
    icon: <FileText size={26} />,
    title: "VAT & Tax Consultancy",
    description: "VAT registration to corporate tax compliance simplified, accurate, and stress-free.",
  },
  {
    icon: <Wifi size={26} />,
    title: "IT & Digital Services",
    description: "Web hosting, business email setup, domain registration, and 24/7 technical support.",
  },
];

export default function CorporateServices() {
  return (
    <section className="bg-[#fafafa] py-16 sm:py-20 px-6">
      <div className="w-full mx-auto max-w-[900px] sm:max-w-[1100px] lg:max-w-[1300px] xl:max-w-[1500px] 2xl:max-w-[1700px] 3xl:max-w-[1900px] px-0 sm:px-6 lg:px-10">
        <div className="text-left md:text-center mb-16">
          <p className="text-[#B8893A] text-xs font-bold uppercase tracking-[0.4em] mb-4">
            Beyond Setup
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-black text-[#000000] mb-5 tracking-tight">
            Our Corporate Services
          </h2>
          <p className="text-gray-500 max-w-2xl md:mx-auto text-lg leading-relaxed">
            Everything you need for sustained growth and full compliance in the UAE.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-11 mb-16">
          {addOns.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08 }}
              className="relative group rounded-2xl p-[1px] bg-gradient-to-br from-transparent via-transparent to-transparent hover:from-[#B8893A]/40 hover:to-[#B8893A]/10 transition-all duration-300"
            >
              <div className="h-full w-full rounded-2xl bg-white/80 backdrop-blur-xl p-5 md:p-7 border border-gray-200 group-hover:border-transparent shadow-sm group-hover:shadow-xl transition-all duration-300">

                {/* Icon */}
                <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-6 
          bg-gradient-to-br from-[#B8893A]/10 to-[#B8893A]/5 
          text-[#B8893A] 
          
          transition-all duration-300 shadow-sm">
                  {item.icon}
                </div>

                {/* Title */}
                <h3 className="text-lg font-semibold text-[#0A0A0A] mb-3 group-hover:text-[#B8893A] transition">
                  {item.title}
                </h3>

                {/* Desc */}
                <p className="text-gray-500 text-sm leading-relaxed mb-6">
                  {item.description}
                </p>

                {/* CTA */}
                <Link
                  href="/contact"
                  className="inline-flex items-center text-xs font-bold uppercase tracking-wider text-[#B8893A] gap-1 group-hover:gap-2 transition-all"
                >
                  Get a Quote
                  <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                </Link>

              </div>
            </motion.div>
          ))}
        </div>
        {/* Bottom CTA */}
        <div className="text-center">
          <Link
            href="/contact"
            className="inline-block px-8 py-3 rounded-xl bg-[#B8893A] text-white font-bold shadow-lg hover:bg-[#A67B34] transition-all hover:scale-105 text-sm"
          >
            Talk to Our Experts
          </Link>
        </div>

      </div>
    </section>
  );
}
